import { useTranslation } from 'react-i18next';

import Button from '../../../../../components/buttons/Button';
import type { GeneralWideWidgetProps } from '../../../types';

import styles from './GeneralWideWidget.module.scss';

export function GeneralWideWidget(props: GeneralWideWidgetProps) {
  const { widgetImageUrl, timer, title, ctaLabel } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <img alt="" className={styles.img} src={widgetImageUrl} />
      <div className={styles.wrapper}>
        {title}
        {timer}
        <div className={styles.btnWrapper}>
          <Button className={styles.btn} dataTestId="general-wide-widget-btn">
            {ctaLabel ?? t('common.view')}
          </Button>
        </div>
      </div>
    </div>
  );
}
